import {
    GET_CONFIG_FORM17, 
    GET_COMBO_MOTIVO_DESCUENTO,
    POST_ACTUALIZAR_SOLICITUD,
    CLEAN_SOLICITUD,
    SET_LOADING_DESCUENTO,
    GET_SOLICITUD_DESCUENTO
} from '../types';
export default function solicitudDescuentoReducer(state = {}, action) {
    switch (action.type) {
        case GET_CONFIG_FORM17:
            return { ...state, cfg_form17:action.payload }
        case GET_COMBO_MOTIVO_DESCUENTO:
            return { ...state, comboMotivoDescuento:action.payload }
        case GET_SOLICITUD_DESCUENTO:
            return { ...state, ...action.payload }
        case SET_LOADING_DESCUENTO:
            return { ...state, loadingDescuento:action.payload }
       
        case POST_ACTUALIZAR_SOLICITUD:
            return { ...state, respuestaModalSolicitud:action.payload }
        case CLEAN_SOLICITUD:
            return { ...state, 
                respuestaModalSolicitud:{} }
       
       
       
       
        default:
            return state
    }
}